require('normalize.css/normalize.css')
require('./styles/index.scss')

import Mouse from "./utils/mouse"
import SimplexNoise from "./utils/simplexNoise"

const colors = [
  "#74EDFF",
  "#C88CFF",
  "#FFFB8C",
  "#FF3F3F",
  "#FFA5F5"
]

let randomColor = colors[Math.floor(Math.random() * colors.length)]

const canvas = document.querySelector('.main-canvas')

const canvasWidth = canvas.width = window.innerWidth * window.devicePixelRatio
const canvasHeight = canvas.height = window.innerHeight * window.devicePixelRatio
const ctx = canvas.getContext("2d")

let time = 0
let mouseX
let mouseY
let random = Math.floor(Math.random() * 100)
let simplex = new SimplexNoise()

const drawWave = (color, size, j) => {
  let steps = 1000
  let scale = size // longueur des vagues & le radius
  let frequency = 15 // distance entre les vagues

  ctx.save()
  ctx.translate(canvasWidth / 2, canvasHeight / 2)
  ctx.lineWidth = 1

  ctx.beginPath()
  ctx.strokeStyle = color

  for (let i = 0; i < steps; i++) {
    let progress = i / steps
    let angle = 2 * Math.PI * progress
    let n = simplex.noise4D(time, Math.cos(angle), Math.sin(angle), j * 0.2) * random
    scale = size + n

    ctx.lineTo(Math.cos(angle) * (scale), Math.sin(angle) * (scale))
  }

  ctx.lineTo(Math.cos(Math.PI * 2) * scale, Math.sin(Math.PI * 2) * scale)

  ctx.stroke()
  ctx.closePath()
  ctx.restore()
}

const update = () => {
  requestAnimationFrame(update)

  mouseX = ((Mouse.cursor[0] + 1) / 2) * canvasWidth
  mouseY = ((Mouse.cursor[1] + 1) / 2) * canvasHeight

  ctx.clearRect(0, 0, canvasWidth, canvasHeight)
  ctx.rect(canvasWidth / 4 - 50, canvasHeight / 4 - 50, canvasWidth / 2 + 100, canvasHeight / 2 + 100)
  ctx.clip()

  for (let j = 0; j < 200; j++) {
    drawWave(randomColor, 1 + (j * 3), j)
  }

  time += 0.01
}

requestAnimationFrame(update)